import styled from 'styled-components';

import { Format } from '../../utils/styles-constants';

const gridGutter = '11px'; // Will be configurable in the admin in the future

const StyledCustomMasonry = styled('div')`
	display: flex;
	justify-content: space-between;
	width: 100%;
`;

const MasonryColumn = styled('div')`
	width: 100%;

	@media ${Format.SmartphoneLandscape}, ${Format.Tablet} {
		width: calc((100% - ${gridGutter}) / 2);
	}

	@media ${Format.SmallDesktop} {
		width: calc((100% - ${gridGutter} * 2) / 3);
	}

	@media ${Format.LargeDesktop} {
		width: calc((100% - ${gridGutter} * 3) / 4);
	}
`;

export {
	StyledCustomMasonry,
	MasonryColumn,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CustomMasonry/styles.ts